import React, { Component } from 'react';

class Homebrewing extends React.Component {
  render() {
    const { name = 'Homebrewing' } = this.props;
    return <h1>Hello, {name}</h1>;
  }
}
export default Homebrewing;
